import React from 'react';
import './About.scss';
import AboutContents1 from './AboutContents/AboutContents1';
import AboutContents2 from './AboutContents/AboutContents2';

const About = ({ setProductPosition }) => {
  return (
    <div className="mq">
      <div id="second" className="about">
        <div className="aboutMain">
          <div className="aboutLogoBox">
            <div>
              <img
                className="Companylogo"
                src="/images/NSW-Logo3.png"
                alt="logo"
              />
            </div>
          </div>
          <div className="aboutTitleBox">
            <div>
              <b>
                서울대학교 Turbomachinery Lab 출신 연구진이 세운 High-Tech
                Product 전문 기업
              </b>
            </div>
          </div>
          <div className="aboutInfoBox">
            <p>제대로 된 기술로</p>
            <p>고객의 일상에 필요한 제품을 개발합니다.</p>
            <p>완전히 새로운 설계로 개발한 </p>
            <p>TUF 무동력팬을 시작으로,</p>
            <p>생활에 필요한 다양한 제품을 선보입니다.</p>
          </div>
        </div>
        <AboutContents1 />
        <AboutContents2 setProductPosition={setProductPosition} />
      </div>
    </div>
  );
};

export default About;
